<button mat-icon-button (click)="closeDialog()" *ngIf="data?.showCloseButton">
    <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
</button>
<div class="product-number" [ngClass]="{'error': noProductFound}">
    <!-- Input field to display and edit the code -->
    <input #productNumberInput type="text"
           matInput
           [(ngModel)]="productNumber"
           (keydown)="onInputKeydown($event)"
           placeholder="{{ 'Ecommerce.POS.insert_product_code' | transloco }}"/>
</div>

<!--&lt;!&ndash; Toggle to show/hide on-screen keyboard &ndash;&gt;-->
<!--<div class="toggle-keyboard">-->
<!--    <mat-slide-toggle [(ngModel)]="showVirtualKeyboard" (change)="onToggleKeyboard()">-->
<!--        {{ 'Ecommerce.POS.show_keyboard' | transloco }}-->
<!--    </mat-slide-toggle>-->
<!--</div>-->

<!-- Optional virtual keyboard -->
<app-virtual-numeric-keyboard *ngIf="showVirtualKeyboard"
                              (keyPress)="onKeyboardInput($event)"></app-virtual-numeric-keyboard>
